import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import { addAndApplyFilter, clearFiltersByName } from '../../actions/filterActions';
import { trackSortEvent } from '../../utils/tracking/searchBrowse/trackSortEvent';
import get from 'lodash.get';

// styles
import styles from './SbRespSortItems.scss';

function SbRespSortItemsComponent(props) {
    const { itemSearch, onChange } = props;
    const selectedValue = get(itemSearch, 'sort.currentOption.urlLabel');
    const options = itemSearch.sort.options.map(sortOption => {
        return {
            value: sortOption.urlLabel,
            label: sortOption.displayName,
        };
    });

    return (
        <div className={styles.container}>
            <BasicSelect
                size="medium"
                value={selectedValue}
                dataTn="sb-resp-sort-by"
                options={options}
                onChange={onChange}
            />
        </div>
    );
}

SbRespSortItemsComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
    return {
        onChange(e) {
            dispatch(clearFiltersByName('sort'));
            dispatch(addAndApplyFilter('sort', { urlLabel: e.target.value }));
            trackSortEvent(e.target.value);
        },
    };
}

export const SbRespSortItems = createFragmentContainer(
    connect(
        null,
        mapDispatchToProps
    )(SbRespSortItemsComponent),
    {
        itemSearch: graphql`
            fragment SbRespSortItems_itemSearch on ItemSearchQueryConnection {
                sort {
                    options {
                        urlLabel
                        displayName
                    }
                    currentOption {
                        urlLabel
                    }
                }
            }
        `,
    }
);
